import { Grid, makeStyles } from "@material-ui/core";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import { useScgpUserQuery } from "@saleor/graphql";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps } from "react-router";
import useRouter from "use-react-router";

import UserDetailFooter from "../components/UserDetailFooter";
import UserDetailForm from "../components/UserDetailForm";
import UserDetailGroup from "../components/UserDetailGroup";
import { FormType, ParentGroupFormType, UserDetailMode } from "../constants";

const useStyles = makeStyles(
  () => ({
    container: {
      paddingBottom: "12rem"
    }
  }),
  { name: "UserDetail" }
);

export interface UserDetailRouteProps {
  id: string;
  mode: string;
}

const UserDetail: React.FC<RouteComponentProps<UserDetailRouteProps>> = ({
  match,
  location
}) => {
  const id = decodeURIComponent(match.params.id);
  const search = new URLSearchParams(location.search);
  const intl = useIntl();
  const classes = useStyles();
  const { history } = useRouter();
  const [groupId, setGroupId] = useState(null);
  const [groupCode, setGroupCode] = useState<string>(null);
  const [formType, setFormType] = useState<FormType>(null);
  const [submitCall, setSubmitCall] = useState<number>(0);

  const [mode, setMode] = useState(
    id === "create"
      ? UserDetailMode.CREATE
      : search.get("edit")
      ? UserDetailMode.EDIT
      : UserDetailMode.VIEW
  );
  const { data: user, refetch: refetchUser } = useScgpUserQuery({
    skip: id === "create",
    displayLoader: true,
    variables: { id }
  });

  useEffect(() => {
    if (user?.scgpUser?.extendData?.userParentGroup?.id) {
      setGroupId(user?.scgpUser?.extendData?.userParentGroup?.id);
      setGroupCode(user?.scgpUser?.extendData?.userParentGroup?.code);
    }
  }, [user]);

  useEffect(() => {
    if (groupCode) {
      setFormType(ParentGroupFormType?.[groupCode] || FormType.OTHER);
    }
  }, [groupCode]);

  const handleSubmit = () => {
    setSubmitCall(submitCall + 1);
  };

  const handleBack = () => {
    history.goBack();
  };

  return (
    <>
      <Container className={classes.container}>
        <AppHeader onBack={handleBack}>
          <MyTypography variant="body3">
            {intl.formatMessage({ defaultMessage: "กลับไป" })}
          </MyTypography>
        </AppHeader>
        <PageHeader
          title={
            mode === UserDetailMode.VIEW
              ? intl.formatMessage({
                  defaultMessage: "ข้อมูลผู้ใช้งาน",
                  description: "label"
                })
              : mode === UserDetailMode.EDIT
              ? intl.formatMessage({
                  defaultMessage: "แก้ไขข้อมูลผู้ใช้งาน",
                  description: "label"
                })
              : intl.formatMessage({
                  defaultMessage: "เพิ่มผู้ใช้งาน",
                  description: "label"
                })
          }
        />
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <UserDetailGroup
              user={user}
              mode={mode}
              groupId={groupId}
              setGroupId={setGroupId}
              setGroupCode={setGroupCode}
            />
          </Grid>
          <Grid item xs={9}>
            {groupId && (
              <UserDetailForm
                user={user}
                mode={mode}
                setMode={setMode}
                submitCall={submitCall}
                refetchUser={refetchUser}
                groupId={groupId}
                groupCode={groupCode}
                formType={formType}
              />
            )}
          </Grid>
        </Grid>
      </Container>
      <UserDetailFooter
        user={user}
        mode={mode}
        setMode={setMode}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default UserDetail;
